import { Cache } from 'aws-amplify'

// Function to manage personalisation data
export const updatePersonalisedData = (updates: any = {}) => {
  const personaliseData = Cache.getItem('personalise') || { urls: [], utm: {}, dogs: [] }

  // Merge updates with existing data
  const updatedData = {
    urls: updates.urls !== undefined ? updates.urls : personaliseData.urls,
    utm: updates.utm !== undefined ? { ...personaliseData.utm, ...updates.utm } : personaliseData.utm,
    dogs: updates.dogs !== undefined ? updates.dogs : personaliseData.dogs
  }

  if (window?.Cookiebot?.consent?.statistics) Cache.setItem('personalise', updatedData)
  return updatedData
}

// Function to capture dogs data from localStorage
export const captureDogData = () => {
  try {
    if (typeof localStorage !== 'undefined') {
      const { dog: json } = JSON.parse(localStorage.getItem('persist:root') || '{}')
      const dog = json ? JSON.parse(json) : null
      const dogs = dog?.dogInfo?.dogs

      if (dogs?.length > 0) {
        // Filter dogs that have names
        const dogsWithNames = dogs.filter((d: any) => d.name)
        if (dogsWithNames.length > 0) {
          updatePersonalisedData({ dogs: dogsWithNames })
        }
      }
    }
  } catch (err) {
    console.error('Error capturing dog data:', err)
  }
}

// Function to get personalised data for API requests
export const getPersonalisedDataForAPI = (base64encode: boolean = true) => {
  const personaliseData = Cache.getItem('personalise') || { urls: [], utm: {}, dogs: [] }
  return base64encode ? btoa(JSON.stringify(personaliseData)) : personaliseData
}

/**
 * Analyzes visitor URLs and returns a health condition if appropriate
 * @param {Array} urls - Array of URL objects with url and timestamp properties
 * @returns {string} Health condition name (falls back to most commonly visited)
 */
export function getHealthConditionText() {
  const { urls } = getPersonalisedDataForAPI(false)

  // Define health pages and their corresponding condition names
  const healthPages: any = {
    '/pancreatitis': 'Pancreatitis',
    '/kidney-support': 'Renal & kidney',
    '/digestion-issues': 'Digestion / IBD',
    '/weight-management': 'Weight management',
    '/itchy-skin': 'Itchy / sensitive skin',
    '/diarrhoea': 'Diarrhoea / anal gland'
  }

  // Count visits to each health page
  const healthPageVisits: any = {}

  // Process each URL
  urls.forEach(urlObj => {
    const url = urlObj.url

    // Check if this URL matches any health page
    Object.keys(healthPages).forEach(healthPage => {
      if (url.startsWith(healthPage)) {
        healthPageVisits[healthPage] = (healthPageVisits[healthPage] || 0) + 1
      }
    })
  })

  // Get unique health pages visited
  const uniqueHealthPagesVisited = Object.keys(healthPageVisits)
  // If no health pages visited, return null
  if (uniqueHealthPagesVisited.length === 0) {
    return null
  }

  // If exactly one health page type visited, return that condition
  if (uniqueHealthPagesVisited.length === 1) {
    const healthPage = uniqueHealthPagesVisited[0]
    return healthPages[healthPage]
  }
  // Otherwise, find the most commonly visited health page
  let mostVisitedPage = uniqueHealthPagesVisited[0]
  let highestVisitCount = healthPageVisits[mostVisitedPage]
  uniqueHealthPagesVisited.forEach(page => {
    if (healthPageVisits[page] > highestVisitCount) {
      mostVisitedPage = page
      highestVisitCount = healthPageVisits[page]
    }
  })
  // Return the condition for the most visited health page
  return healthPages[mostVisitedPage]
}
